import type {AuditInfo} from "../common/audit-info";

type NoteType = 'TODO' | 'NOTE';

export type NoteStatus = 'ACTIVE' | 'COMPLETED';

export enum Priority {
    HIGH = "High Priority",
    MEDIUM = "Medium Priority",
    LOW = 'Low Priority'
}

export interface Note {
    title?: string;
    id: string;
    content: string;
    dueDate?: string;
    status: NoteStatus;
    priority?: keyof typeof Priority;
    colorKey?: string;
    type?: NoteType;
    tag?: string[];
    pinned?: boolean;
    auditInfo?: AuditInfo;
}

